import { ADD_NOTIC, DELETE_NOTIC, GET_NOTIC, UPDATE_NOTIC } from "../Constant";

export function addNotic(data) {
    return {
        type: ADD_NOTIC,
        payload: data
    }
}

export function getNotic() {
    return {
        type: GET_NOTIC
    }
}

export function updateNotic(data) {
    return {
        type: UPDATE_NOTIC,
        payload: data
    }
}

export function deleteNotic(data) {
    return {
        type: DELETE_NOTIC,
        payload: data
    }
}